import jsonMakeup from './myStoreUpdated.json'

type ProductIntensity = {
    sku: string
    defaultValue: number
    min: number
    max: number
}


function getProductsWithVaryingIntensity(): ProductIntensity[] {
    let result: ProductIntensity[] = []

    for (let makeup of jsonMakeup) {
        if (makeup.opacityLimits) {
            result.push({
                sku: makeup.sku,
                defaultValue: makeup.opacity,
                min: makeup.opacityLimits.min,
                max: makeup.opacityLimits.max,
            });
        }
    }

    return result
}

type OAPMode = 'Smokey' | 'Halo';

function getOAPProducts(): { sku: string; parentsku: string; mode: OAPMode }[] {
    let result: { sku: string; parentsku: string; mode: OAPMode }[] = []

    for (let makeup of jsonMakeup) {
        if (makeup.OAPMode) {
            result.push({
                sku: makeup.sku,
                parentsku: makeup.parentSku,
                mode: makeup.OAPMode as OAPMode,
            });
        }
    }

    return result
}

function isOAPProduct(sku: string): boolean {
    const oapProducts = getOAPProducts();
    console.log("OAP Products:", oapProducts);
    return oapProducts.some(product => (product.sku.includes(sku) || product.parentsku === sku));
}

function getProductsForOAPMode(mode: OAPMode): { sku: string; parentsku: string }[] {
    let result: { sku: string; parentsku: string }[] = []

    for (let makeup of jsonMakeup) {
        if (makeup.OAPMode === mode) {
            result.push({
                sku: makeup.sku,
                parentsku: makeup.parentSku
            });
        }
    }

    return result
}

export { getProductsWithVaryingIntensity, getOAPProducts, isOAPProduct, getProductsForOAPMode }
export type { ProductIntensity, OAPMode }